export default {
  listaToast: [],
  listaNotificacoesExibidas: [],
  itemSelecionadoID: null
}
